import cn from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from '../../col';
import { Icon } from '../../icons';
import { Row } from '../../row';
import { Tag } from '../../tag';
import { Text, Title } from '../../typography';
import styles from './empty-state.module.css';

type P = {
  className?: string;
  description?: ReactNode;
  filterName?: string;
  icon?: ReactNode;
  isFiltered?: boolean;
  name: ReactNode;
};

const EmptyState = ({ className, description, filterName, icon, isFiltered, name }: P) => {
  const { t } = useTranslation(['translationReactComponents']);
  const { t: translate } = useTranslation();
  const translatedFilterName = typeof filterName === 'string' ? translate(filterName).toLowerCase() : filterName;
  const translatedDescription = typeof description === 'string' ? translate(description) : description;
  const translatedName = typeof name === 'string' ? translate(name) : name;

  return (
    <Row align="middle" className={cn(styles.empty, className)} gutter={[0, 'lg']} justify="center">
      <Col flex="none" span={24}>
        <Tag
          icon={
            <Text type="secondary">
              {isFiltered ? (
                <Icon icon="search-2-line" size="large" />
              ) : (
                (icon ?? <Icon icon="inbox-2-line" size="large" />)
              )}
            </Text>
          }
          rounded
          size="large"
        />
      </Col>
      <Col flex="none" span={24}>
        <Title className={styles.title} level={5}>
          {isFiltered
            ? t('emptyState.titleFiltered', { name: translatedFilterName })
            : t('emptyState.title', {
                name: typeof translatedName === 'string' ? translatedName.toLowerCase() : translatedName,
              })}
        </Title>
        <Text>
          {isFiltered
            ? t('emptyState.descriptionFiltered')
            : (translatedDescription ?? t('emptyState.description', { name: translatedName }))}
        </Text>
      </Col>
    </Row>
  );
};

export default EmptyState;
